// extracted by mini-css-extract-plugin
export default {"cls1":"I_1YSSVa6S2Nug9e3dea","cls2":"Of5PYFfuue_eeN1F52sw I_1YSSVa6S2Nug9e3dea"};